import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { openClose } from '@core/animations/animations';
import { LLCFunctions } from '@functions/llc.service';
import LogRocket from 'logrocket';
import { firstValueFrom, Subject } from 'rxjs';
import { ICON } from '@core/util/icon';

export interface DownloadLLCDocumentsData {
	transactionId: string;
	matterMortgageId: string;
	matterId: string;
}

interface DocumentVM {
	selected: boolean;
	date: string;
	name: string;
	id: string;
	source: string;
	downloading?: boolean;
	uplaoding?: boolean;
	error?: boolean;
	success?: boolean;
}

@Component({
	selector: 'app-download-documents',
	templateUrl: './download-documents.component.html',
	styleUrls: ['./download-documents.component.scss'],
	animations: [openClose()],
	standalone: false,
})
export class DownloadDocumentsComponent implements OnInit {
	public matterMortgageId: string;
	public transactionId: string;
	public matterId: string;
	public result: number;

	public loadingStatus: string;
	public loading = true;
	public dataError = false;
	public ICON = ICON;
	public documents: DocumentVM[];
	public submitSubject: Subject<void> = new Subject<void>();
	public uploadErrors: string[] = [];
	public selected: string[] = [];

	constructor(
		public dialogRef: MatDialogRef<DownloadDocumentsComponent>,
		@Inject(MAT_DIALOG_DATA) public _data: DownloadLLCDocumentsData,
		private llcFunctions: LLCFunctions,
	) {
		this.transactionId = _data.transactionId;
		this.matterMortgageId = _data.matterMortgageId;
		this.matterId = _data.matterId;
	}

	async ngOnInit(): Promise<void> {
		this.dialogRef.addPanelClass('download-document-modal');
		await this.GetDocuments();
	}

	addError(name) {
		this.uploadErrors.push(name);
	}

	close() {
		this.dialogRef.close();
	}

	private async GetDocuments(): Promise<void> {
		if (this.transactionId) {
			try {
				this.loadingStatus = 'Fetching new documents';
				this.loading = true;
				this.dataError = false;

				const _result = await firstValueFrom(
					this.llcFunctions.fetchNewDocuments(
						this.transactionId,
						this.matterId,
						this.matterMortgageId,
					),
				);
				console.log('Fetch new documents result', _result);

				this.result = _result.results
					?.filter((x) => x.success)
					?.map((x) => x.documentName)?.length;

				this.loadingStatus = 'Documents fetched successfully';
			} catch (err) {
				console.error('Document fetch failed:', err);
				this.addError('Failed to fetch new documents from LLC.');
				LogRocket.log('Error fetching llc documents', err);
				this.dataError = true;
			} finally {
				this.loading = false;
			}
		}
	}
}
